<template>
  <div>
    <div v-for="(item, inde) in items" :key="inde" class="ui-timeLine">
      <div style="margin: 40px 0">
        <h2>
          {{ item.title }}
        </h2>
      </div>
      <div v-for="(items, idex) in item.webDevelopmentTimeLineList" :key="idex" class="list_line">
        <div class="lint_title">
          <h3>{{ items.year }}</h3>
        </div>
        <div v-for="(itemd, idx) in items.webDevelopmentDetailsList" class="item_list" :key="idx">
          <div class="line"></div>
          <div class="dot"></div>
          <div class="box">
            <div class="cbox">
              <div class="date">{{ itemd.time }}</div>
              <div class="title">{{ itemd.content }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="activeLine"></div>
    </div>
  </div>
</template>

<script>
import { histroyList } from "@/api/history/index"
export default {
  data() {
    return {
      items: [
        
      ],
    };
  },
  mounted() {
    this.gethistroyList();
  },
  methods: {

    gethistroyList(){
      histroyList().then(res =>{
        this.items = res.rows;
        setTimeout(() => {
          this.uiTimeLine();
        }, 500);
        
      })
    },


    uiTimeLine() {
      var $timeLine = $(".ui-timeLine");
      var $activeLine = $(".ui-timeLine .activeLine");
      var $dots = $(".ui-timeLine .dot");
      var $cboxs = $(".ui-timeLine .item_list .cbox");
      function setActiveLineHeight() {
        let height = $(document).scrollTop() + window.screen.height;
        let j = 0;
        for (let i = 0; i < $dots.length; i++) {
          if ($($dots[i]).offset().top < height) {
            $($($dots[i])).addClass("active");
            $($cboxs[i]).css({
              left: 0,
            });
            j = i;
          } else {
            $($($dots[i])).removeClass("active");
            $($cboxs[i]).css({
              left: "100vw",
            });
          }
        }
        $activeLine.css({
          height: $($dots[j]).offset().top - $timeLine.offset().top + 40 + "px",
        });
      }
      $(window).on("scroll", setActiveLineHeight);
      setActiveLineHeight();
    },
  },
};
</script>

<style lang="less" scoped>
.lint_title h3 {
  position: relative;
  left: 50px;
  margin: 20px 0px;
  
}


.ui-timeLine {
  //   padding: 50px 0;
  position: relative;
  overflow: hidden;
}

.ui-timeLine > .list_line > .item_list {
  display: block;
  position: relative;
  text-align: justify;
  text-justify: newspaper;
  word-break: break-all;
  padding-left: 50px;
  color: #fff;
  padding-right: 10px;
}

.ui-timeLine > .list_line > .item_list > .box {
  padding: 5px 0;
}

.ui-timeLine > .list_line > .item_list .cbox {
  position: relative;
  left: 100vw;
  transition: left 1s;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 3px 3px 8px #ccc;
  background: linear-gradient(180deg, #0a529b 0, #0a529b 100%);
}

.ui-timeLine > .list_line > .item_list::after {
  content: "";
  display: block;
  clear: both;
}

.ui-timeLine .dot {
  z-index: 51;
  display: inline-block;
  position: absolute;
  left: 25px;
  top: 0;
  padding: 3px;
  border: 3px solid #eee;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 3px 3px 8px #ccc;
  transition: 0.5s;
}

.ui-timeLine .active {
  border: 3px solid rgba(132, 43, 171, 0.8);
}

.ui-timeLine .line,
.ui-timeLine > .activeLine {
  position: absolute;
  left: 29px;
  width: 4px;
  height: 100%;
  background-color: #eee;
}

.ui-timeLine .date {
  font-size: 16px;
}

.ui-timeLine .title {
  font-size: 18px;
  line-height: 30px;
}

.ui-timeLine .types > span {
  font-size: 10px;
  border-radius: 5px;
  padding: 2px 10px;
  margin-right: 10px;
  border: 1px solid #fff;
}

.ui-timeLine > .activeLine {
  background-color: rgba(0, 200, 255, 0.8);
  z-index: 50;
  top: 100px;
  height: 0;
  max-height: calc(100% - 80px);
  transition: height 1s;
  box-shadow: 3px 3px 2px #eee;
}
</style>